export const DecimalPlacesOption = [
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const FIELD_TYPE = {
  LABEL: "Label",
  TOGGLE: "Toggle",
  INPUT_RADIO: "Input Radio",
  INPUT_DROPDOWN: "Input Dropdown",
  INPUT_TEXT: "Input Text",
  INPUT_NUMBER: "Input Number",
  INPUT_EMAIL: "Input Email",
  INPUT_CURRENT_TIME: "Input Current Time",
  INPUT_DATE: "Input Date",
  INPUT_DATE_AND_TIME: "Input Date and Time",
  LINKED_FIELD: "Linked Field",
  HYPERLINK: "Hyperlink",
  BARCODE: "Barcode",
  FILE_UPLOAD: "File Upload",
  CALCULATION: "Calculation",
  IMAGE_UPLOAD: "Image Upload",
  INPUT_CHECKBOX: "Input Checkbox",
  INPUT_AUTOINCREMENT: "Auto Increment",
};

export const VisualDisplay = [
  { value: "none", label: "None" },
  { value: "above", label: "Above" },
  { value: "below", label: "Below" },
  { value: "left", label: "Left side" }, //@info apply seprator to both side and up-down.
  { value: "right", label: "Right side" },
  { value: "left_right_both", label: "Left and Right" },
  { value: "both", label: "Above and below" },
];

export const LayoutOption = [
  { value: 12, label: "Full Layout" },
  { value: 6, label: "Row Layout of 2 Inputs" },
  { value: 4, label: "Row Layout of 3 Inputs" },
  { value: 3, label: "Row Layout of 4 Inputs" },
  { value: 2, label: "Row Layout of 6 Inputs" },
];

export const TimeFormat = [
  { value: "hh:mm A", label: "12 hour" },
  { value: "HH:mm", label: "24 hour" },
];

export const TimeFormatDisplay = [
  { value: "HH :MM", label: "HH:MM" }, //@info Time Display Format is only support standard minutes and hours format.
  // { value: "HH :MM :SS", label: "HH:MM:SS" },
  // { value: "[HH]:[MM]:[SS]", label: "[HH]:[MM]:[SS]" },
];

export const BarCodeOption = [
  { value: "UPC", label: "UPC" },
  { value: "EAN", label: "EAN" },
  { value: "Code 128", label: "Code 128" },
  { value: "Code 39", label: "Code 39" },
  { value: "PDF417", label: "PDF417" },
];

export const DateFormat = [
  { value: "DD/MM/YY", label: "DD/MM/YY" },
  { value: "MM/DD/YY", label: "MM/DD/YY" },
  { value: "YY/MM/DD", label: "YY/MM/DD" },
  { value: "DD-MM-YY", label: "DD-MM-YY" },
  { value: "MM-DD-YY", label: "MM-DD-YY" },
  { value: "YY-MM-DD", label: "YY-MM-DD" },
  { value: "MM", label: "MM" },
  { value: "MM/YYYY", label: "MM/YYYY" },
  { value: "MM-YYYY", label: "MM-YYYY" },
  { value: "YYYY", label: "YYYY" },
];

export const FileSize = [
  { value: "Bytes", label: "Bytes" },
  { value: "Kilobytes (KB)", label: "Kilobytes (KB)" },
  { value: "Megabytes (MB)", label: "Megabytes (MB)" },
];
export const MultiUploadOptions = [
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
];
export const TABS = {
  GENERAL: "General",
  NOTE: "Note",
  VALIDATIONS: "Validations",
  LABEL: "Label",
  TOGGLE: "Toggle",
  INPUT_RADIO: "Input Radio",
  INPUT_DROPDOWN: "Input Dropdown",
  INPUT_TEXT: "Input Text",
  INPUT_NUMBER: "Input Number",
  STATIC_NUMBER: "Static Number",
  INPUT_EMAIL: "Input Email",
  INPUT_CURRENT_TIME: "Input Current Time",
  INPUT_DATE: "Input Date",
  INPUT_DATE_AND_TIME: "Input Date and Time",
  LINKED_FIELD: "Linked Field",
  HYPERLINK: "Hyperlink",
  BARCODE: "Barcode",
  FILE_UPLOAD: "File Upload",
  CALCULATION: "Calculation",
  FORMULA_VARIABLES: "Formula Variables",
  CONDITION: "Condition",
  DEPENDENCY: "Dependency",
  IMAGE_UPLOAD: "Image Upload",
  INPUT_CHECKBOX: "Input Checkbox",
  INPUT_AUTOINCREMENT: "Input Auto Increment",
  MANUAL_CONDITION: "Manual Condition",
};

export const tabPropertyKeys = {
  [TABS.GENERAL]: ["general"],
  [TABS.NOTE]: ["note"],
  [TABS.VALIDATIONS]: ["validations"],
  [TABS.LABEL]: ["default_value", "restricted_num", "restricted_spl_char"],
  [TABS.TOGGLE]: ["toggle"],
  [TABS.INPUT_RADIO]: ["input_radio", "options"],
  [TABS.INPUT_DROPDOWN]: ["input_dropdown", "options"],
  [TABS.INPUT_CHECKBOX]: ["input_checkbox", "options"],
  [TABS.INPUT_AUTOINCREMENT]: ["auto_increment"],
  [TABS.INPUT_TEXT]: ["input_text"],
  [TABS.INPUT_NUMBER]: ["input_number"],
  [TABS.INPUT_EMAIL]: ["input_email"],
  [TABS.INPUT_CURRENT_TIME]: ["input_current_time"],
  [TABS.INPUT_DATE]: ["input_date"],
  [TABS.INPUT_DATE_AND_TIME]: ["input_date_and_time"],
  [TABS.LINKED_FIELD]: ["linked_field"],
  [TABS.HYPERLINK]: ["hyperlink"],
  [TABS.BARCODE]: ["barcode"],
  [TABS.FILE_UPLOAD]: ["file_upload"],
  [TABS.CALCULATION]: ["calculation", "input_calculation_variables"],
  [TABS.FORMULA_VARIABLES]: [],
  [TABS.CONDITION]: ["conditions"],
  [TABS.DEPENDENCY]: [],
  [TABS.IMAGE_UPLOAD]: ["image_upload"],
};

export const TabPresetMap = {
  [FIELD_TYPE.LABEL]: [TABS.GENERAL, TABS.NOTE],
  [FIELD_TYPE.TOGGLE]: [TABS.GENERAL, TABS.TOGGLE, TABS.NOTE, TABS.VALIDATIONS],
  [FIELD_TYPE.INPUT_TEXT]: [
    TABS.GENERAL,
    TABS.INPUT_TEXT,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_RADIO]: [
    TABS.GENERAL,
    TABS.INPUT_RADIO,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.CONDITION,
  ],
  [FIELD_TYPE.INPUT_DROPDOWN]: [
    TABS.GENERAL,
    TABS.INPUT_DROPDOWN,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.CONDITION,
    TABS.MANUAL_CONDITION,
  ],
  [FIELD_TYPE.INPUT_CHECKBOX]: [
    TABS.GENERAL,
    TABS.INPUT_CHECKBOX,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.CONDITION,
  ],
  [FIELD_TYPE.INPUT_NUMBER]: [
    TABS.GENERAL,
    TABS.INPUT_NUMBER,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_EMAIL]: [
    TABS.GENERAL,
    TABS.INPUT_EMAIL,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_CURRENT_TIME]: [
    TABS.GENERAL,
    TABS.INPUT_CURRENT_TIME,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.DEPENDENCY,
  ],
  [FIELD_TYPE.INPUT_DATE]: [
    TABS.GENERAL,
    TABS.INPUT_DATE,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.DEPENDENCY,
  ],
  [FIELD_TYPE.INPUT_DATE_AND_TIME]: [
    TABS.GENERAL,
    TABS.INPUT_DATE_AND_TIME,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.DEPENDENCY,
  ],
  [FIELD_TYPE.LINKED_FIELD]: [
    TABS.GENERAL,
    TABS.LINKED_FIELD,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.HYPERLINK]: [
    TABS.GENERAL,
    TABS.HYPERLINK,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.BARCODE]: [TABS.GENERAL, TABS.NOTE],
  [FIELD_TYPE.FILE_UPLOAD]: [
    TABS.GENERAL,
    TABS.FILE_UPLOAD,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.CALCULATION]: [
    TABS.GENERAL,
    TABS.FORMULA_VARIABLES,
    TABS.CALCULATION,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.IMAGE_UPLOAD]: [
    TABS.GENERAL,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.IMAGE_UPLOAD,
  ],
  [FIELD_TYPE.INPUT_AUTOINCREMENT]: [
    TABS.GENERAL,
    TABS.INPUT_AUTOINCREMENT,
    TABS.NOTE,
  ],
};

export const page = 1;
export const limit = 999;

//@info config for the API triggering in case of the date, date and time and current time input fields
export const DEPENDENCY_CONFIG = {
  [FIELD_TYPE.INPUT_CURRENT_TIME]: {
    routeType: "time",
    basePath: "input_current_time",
    greaterKey: "time_greater_than",
    lessKey: "time_less_than",
    payloadGreaterKey: "greater_than",
    payloadLessKey: "less_than",
  },

  [FIELD_TYPE.INPUT_DATE]: {
    routeType: "date",
    basePath: "input_date",
    greaterKey: "date_greater_than",
    lessKey: "date_less_than",
    payloadGreaterKey: "date_greater_than",
    payloadLessKey: "date_less_than",
  },

  [FIELD_TYPE.INPUT_DATE_AND_TIME]: {
    routeType: "datetime",
    basePath: "input_date_and_time",
    greaterKey: "datetime_greater_than",
    lessKey: "datetime_less_than",
    payloadGreaterKey: "datetime_greater_than",
    payloadLessKey: "datetime_less_than",
  },
};
